import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DictionaryPapIndexDialogData, DictionaryPapIndexEntity } from '../types';

@Injectable({
  providedIn: 'root',
})
export class DictionaryPapIndexDataService {
  url = '/api/dictionary/pap-index';

  constructor(private http: HttpClient) {}

  getAll(): Observable<DictionaryPapIndexEntity[]> {
    return this.http.get<DictionaryPapIndexEntity[]>(this.url);
  }

  getAuxiliaryData(): Observable<DictionaryPapIndexDialogData> {
    return this.http.get<DictionaryPapIndexDialogData>(`${this.url}/aux`);
  }

  add(request: DictionaryPapIndexEntity): Observable<DictionaryPapIndexEntity> {
    return this.http.post<DictionaryPapIndexEntity>(this.url, request);
  }

  delete(id: number): Observable<void> {
    const parameter = { id: id };
    return this.http.delete<void>(this.url, { body: parameter });
  }
}
